import { AccountIdCard } from "@/components/common/AccountIdCard";

export const Settings = () => {
  return (
    <div className="dashboard-page">
      <div className="page-heading">
        <div>
          <h1 className="page-title">Settings</h1>
        </div>
      </div>

      <div className="space-y-4">
        <AccountIdCard />
      </div>
    </div>
  );
};
